import i18n from '@dms/i18n';

export const DISCOUNT_TYPE_OPTIONS = [
  {
    value: 'PURCHASE_PRICE' as const,
    label: i18n.t('entity.warehouse.labels.discountOnPurchasePrice'),
  },
  {
    value: 'RECOMMENDED_PRICE' as const,
    label: i18n.t('entity.warehouse.labels.discountOnRecommendedPrice'),
  },
] as const;
